<template>
  <div style="padding-top: 1em;">

    <b-loading :active="isActive === null" :is-full-page="false" />

    <b-field v-if="isActive !== null"
      :message="$t('notifications.message1')">
      <b-switch v-model="isActive">
        {{$t('notifications.message2')}}
      </b-switch>
    </b-field>

    <div v-if="isActive" class="notifications-frequency">
      <div class="field">
        <b-radio v-model="frequency" native-value="daily">
          {{$t('notifications.message3')}}
        </b-radio>
      </div>
      <div class="field">
        <b-radio v-model="frequency" native-value="all">
          {{$t('notifications.message4')}}
        </b-radio>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      isActive: null,
      frequency: 'daily',
    }
  },
  watch: {
    '$route.params.bien' () {
      this.getData()
    },
    '$store.state.inv.biens' () {
      this.getData()
    },
    async value () {
      if (this.savedValue !== this.value) {
        await this.$store.dispatch('inv/setBienNotifications', {
          id: +this.$route.params.bien,
          value: this.value,
        })
      }
    },
  },
  computed: {
    value () {
      if (!this.isActive) return 'none'
      return this.frequency
    },
    savedValue () {
      const bien = this.$store.getters['inv/bien'](+this.$route.params.bien)
      return bien ? bien.notifications : null
    },
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      const bien = this.$store.getters['inv/bien'](+this.$route.params.bien)
      if (!bien) return
      let value = 'daily' // valeur par défaut

      if (bien.notifications !== null) {
        value = bien.notifications
      }

      if (value === 'none') {
        this.isActive = false
      } else {
        this.isActive = true
        this.frequency = value // ---> A remettre une fois la correction mise en place
        // this.frequency = "daily"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.notifications-frequency {
  padding: 0 2em;

  .field {
    padding-top: 1em;
  }
}
</style>
